export const categoriesData = [
  {
    id: 1,
    img: "images/allcategories.png",
    title: "All Categories",
  },
  {
    id: 2,
    img: "images/tire.jpg",
    title: "Tires",
  },

  {
    id: 3,
    img: "images/battery.png",
    title: "Batteries",
  },
  {
    id: 4,
    img: "images/helmet.jpg",
    title: "Helmets",
  },
  {
    id: 6,
    img: "images/motor.png",
    title: "Motors",
  },
  {
    id: 8,
    img: "images/headlight.jpg",
    title: "HeadLights",
  },
  {
    id: 9,
    img: "images/headphones.jpg",
    title: "Gadgets",
  },
];

export const serviceItems = [
  {
    id: 1,
    img: "/images/allcategories.png",
    title: "All Categories",
  },
  {
    id: 2,
    img: "/images/cars.png",
    title: "Cars",
  },
  {
    id: 3,
    img: "/images/bikes.png",
    title: "Bikes",
  },
  {
    id: 4,
    img: "/images/generators.png",
    title: "Generators",
  },
  {
    id: 5,
    img: "/images/refrigerator.png",
    title: "Refrigerators",
  },
];

export const packages = [
  {
    name: "Car Services",
    b1: "GENERAL CAR CHECK-UP/INSPECTION",
    b2: "TUNNING & MAINTANANCE",
    b3: "BRAKE SERVICE/REPLACEMENT",
    price: 2,
    img: "images/cars.png",
    category: "Cars",
  },
  {
    name: "Bike Services",
    b1: "GENERAL BIKE CHECK-UP/INSPECTION",
    b2: "TUNNING & MAINTANANCE",
    b3: "BRAKE SERVICE/REPLACEMENT",
    price: 2,
    img: "images/bikes.png",
    category: "Bikes",
  },
  {
    name: "Generator",
    b1: "GENERAL CHECK-UP/INSPECTION",
    b2: "TUNNING & MAINTANANCE",
    b3: "Repair SERVICE/REPLACEMENT",
    price: 2,
    img: "images/generators.png",
    category: "Generators",
  },
  {
    name: "Refrigerator",
    b1: "GENERAL CHECK-UP/INSPECTION",
    b2: "TUNNING & MAINTANANCE",
    b3: "Repari SERVICE/REPLACEMENT",
    price: 2,
    img: "images/refrigerator.png",
    category: "Refrigerators",
  },
];

export const apiURL = "https://digital-mechanic-server.onrender.com";
